/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingHistoryViewModel } from '../../models/setting-history-view-model';

export interface GetSettingHistory$Params {
  settingId: number;
  hierarchyType?: string;
  hierarchyLevel?: string;
  entityId?: string;
}

export function getSettingHistory(http: HttpClient, rootUrl: string, params: GetSettingHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingHistoryViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getSettingHistory.PATH, 'get');
  if (params) {
    rb.path('settingId', params.settingId, {});
    rb.query('hierarchyType', params.hierarchyType, {});
    rb.query('hierarchyLevel', params.hierarchyLevel, {});
    rb.query('entityId', params.entityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SettingHistoryViewModel>>;
    })
  );
}

getSettingHistory.PATH = '/api/v1/Settings/GetSettingHistory/{settingId}';
